module.exports = __webpack_public_path__ + "img/vod-03.a53b2e3b.jpg";